import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface Expense {
  expense_id: number
  company_id: number
  expense_title: string
  category: string
  cost_center_id: number
  profit_center_id: number
  priority: string
  amount: number
  currency: string
  expense_date: string
  vendor_name: string
  reference_no: string
  requested_by: string
  description: string
  status: string
}

export interface CostCenterOption {
  cost_center_id: number
  center_name: string
}

export interface ProfitCenterOption {
  profit_center_id: number
  center_name: string
}

// ─── Expense APIs ─────────────────────────────────────────────────────────────

export const getExpenses = async (companyId: string): Promise<Expense[] | undefined> => {
  return await axios
    .get(`${API_URL}/expense/${companyId}/list`)
    .then((response: AxiosResponse<Expense[]>) => response.data)
    .then((response: Expense[]) => response)
}

export const createExpense = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/expense/`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const deleteExpense = async (
  companyId: string,
  expenseId: number
): Promise<{detail: string} | undefined> => {
  return await axios
    .delete(`${API_URL}/expense/${companyId}/${expenseId}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}

// ─── Options APIs (for form dropdowns) ───────────────────────────────────────

export const getCostCenterOptions = async (
  companyId: string
): Promise<CostCenterOption[] | undefined> => {
  return await axios
    .get(`${API_URL}/cost-center/${companyId}/list`)
    .then((response: AxiosResponse<CostCenterOption[]>) => response.data)
    .then((response: CostCenterOption[]) => response)
}

export const getProfitCenterOptions = async (
  companyId: string
): Promise<ProfitCenterOption[] | undefined> => {
  return await axios
    .get(`${API_URL}/profit-center/${companyId}/list`)
    .then((response: AxiosResponse<ProfitCenterOption[]>) => response.data)
    .then((response: ProfitCenterOption[]) => response)
}
